module.exports = __webpack_public_path__ + "img/img2.6861a4e2.png";